import { render, staticRenderFns } from "./no-sidebar.vue?vue&type=template&id=f5203d16&scoped=true&"
import script from "./no-sidebar.vue?vue&type=script&lang=js&"
export * from "./no-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./no-sidebar.vue?vue&type=style&index=0&id=f5203d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5203d16",
  null
  
)

export default component.exports